import { UPDATE_SALESMAN_LIST, SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './actionTypes';
import { salesmanlist } from '@/api/business-manage';
import { qiniuInfo } from '@/api/common'

export const updateSalesmanList = async ({ commit }) => {
  let postData = {
  	page_index: '1',
  	page_size: '999'
  }
  const { data, status } = await salesmanlist(postData);
  if (status === 200) {
	  commit(UPDATE_SALESMAN_LIST, data.data)
	}
  // commit(SET_BUCKET_DOMAIN, response.data.BucketDomain)
}

export const getUrlAndTokenOfImageUpload = async ({ commit }) => {
  const response = await qiniuInfo()
  commit(SET_BUCKET_DOMAIN, response.data.BucketDomain)
  commit(SET_BUCKET_DOMAIN_TOKEN, response.data.token)
}
